module.exports = __webpack_public_path__ + "img/N1F2_new.5cdeec33.jpg";